// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.065 18.065\">\n    <path d=\"M0,0H18.065V18.065H0Z\" fill=\"none\"/>\n    <path d=\"M6,6h9.032v9.032H6Z\" transform=\"translate(-1.484 -1.484)\" fill=\"currentColor\"/>\n</svg>\n";
// Exports
module.exports = code;